import React from "react";
import { languages } from "../../constants/languages";
import { FeaturesHeader } from "./FeaturesHeader";
import Grid from "@material-ui/core/Grid";
import moment from "moment-timezone";
import VotesContainer from "../../containers/features/VotesContainer";
// import Button from "@material-ui/core/Button";
// import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import MessagesContainer from "../../containers/features/MessagesContainer";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

export const FeatureDetails = props => (
  <div
    style={{
      width: "100%",
      minHeight: 500,
      overflowX: "hidden",
      marginTop: 80
    }}
  >
    <FeaturesHeader
      user={props.user}
      userData={props.userData}
      handleBackClick={props.handleBackClick}
    />
    {/* ¬ */}
    <Grid container spacing={0}>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <div style={{ padding: 16 }}>
          <Paper>
            <div style={{ padding: 15 }}>
              <div style={{ padding: "15px 20px", lineHeight: 1.6 }}>
                {props.feature.ideaString}
              </div>
              <div style={{ padding: "15px 20px" }}>
                {moment
                  .unix(props.feature.date)
                  .format(languages.features.dateFormat)}
                <br />
                <br />
                <Chip
                  size="small"
                  style={{ margin: 5 }}
                  label={languages.features.categories[props.feature.category]}
                />
                {props.feature.underDev && (
                  <Chip
                    style={{ background: "#ffd690", margin: 5 }}
                    size="small"
                    label={languages.features.underDev}
                  />
                )}
                {props.feature.done && (
                  <Chip
                    style={{ background: "#d7f5a1", margin: 5 }}
                    size="small"
                    label={languages.features.done}
                  />
                )}
              </div>
              {props.isAdmin && (
                <div style={{ padding: "0 20px" }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={props.feature.underDev || false}
                        onChange={props.handleStatusChange}
                        color="primary"
                        name="underDev"
                      />
                    }
                    label={languages.features.underDev}
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={props.feature.done || false}
                        onChange={props.handleStatusChange}
                        color="primary"
                        name="done"
                      />
                    }
                    label={languages.features.done}
                  />
                </div>
              )}
            </div>

            <VotesContainer user={props.user} featureId={props.feature.id} />
          </Paper>
        </div>
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <div style={{ padding: 16 }}>
          <MessagesContainer
            user={props.user}
            featureId={props.feature.id}
            admins={props.admins}
            isAdmin={props.isAdmin}
          />
        </div>
      </Grid>
    </Grid>
  </div>
);
